import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "duration",
  standalone: true,
  pure: true
})
export class DurationPipe implements PipeTransform {
  transform(ms: number, hideHours: boolean = false): string {
    const totalSeconds = Math.floor(ms / 1000);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    if (hideHours) {
      return `${this.pad(minutes)}:${this.pad(seconds)}`;
    }

    return `${this.pad(hours)}:${this.pad(minutes)}:${this.pad(seconds)}`;
  }

  private pad(num: number): string {
    return num < 10 ? "0" + num : num.toString();
  }
}
